import { Button } from "@shared/ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ConsumerSummary } from "../summary";
import { ConsumerList } from "../list";

const ConsumerManagementLandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="page-title">
            Consumer Management
          </h1>
          <p className="page-subtitle">
            View, filter and manage consumer accounts and relationships.
          </p>
        </div>
        <Button
          onClick={() => {
            localStorage.removeItem("new-application-progress");
            localStorage.removeItem("consumerFirstStepData");
            navigate("/cx/consumer-management/create");
          }}
        >
          <Plus className="mr-2 h-4 w-4" />
          New Consumer
        </Button>
      </div>

      <ConsumerSummary />

      <ConsumerList />
    </div>
  );
};

export default ConsumerManagementLandingPage;
